import { create } from 'zustand'
import cards from "../cards.json";


type Card = {
  cardId: number,
  numbers: (number | null)[]
}

type SelectedCardandChip = {
  cardId: number,
  numbers: (number | null)[]
  price: number
}

type CardStore = {
  cards: Card[]
  selectedCardandChip: SelectedCardandChip[]
  selectCard: (id: number, numbers: (number | null)[], price: number) => void
  deselectCard: (id: number) => void
  reset: () => void
}

export const useCardStore = create<CardStore>((set, get) => ({
  cards: cards.map(card => ({ cardId: Number(card.card_id), numbers: JSON.parse(card.numbers) })),
  selectedCardandChip: [],// [{ cardId: 5, price: 5 }, { cardId: 6, price: 5 }, { cardId: 10, price: 5 }, { cardId: 50, price: 5 }, { cardId: 60, price: 5 }],

  selectCard: (id, numbers, price) => {
    const selected = get().selectedCardandChip;
    if (selected.filter(i => i.cardId === id).length === 0) {
      set({ selectedCardandChip: [...selected, { cardId: id, numbers, price }] })
    }
  },

  deselectCard: (id) => {
    set({ selectedCardandChip: get().selectedCardandChip.filter((i) => i.cardId !== id) })
  },
  reset: () => set({ selectedCardandChip: [] })
}))